import { render, staticRenderFns } from "./alerter.vue?vue&type=template&id=16a7200c&"
import script from "./alerter.vue?vue&type=script&lang=js&"
export * from "./alerter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports